import { PrivacyPoliceModel } from '@/models/privacy-police.model';
import { Observable } from 'rxjs';
import { axiosInstance } from './axios.config.api';
import { map } from 'rxjs/operators';

export default class PrivacyPoliceApi {
    getPrivacyPolice(): Observable<PrivacyPoliceModel> {
        return axiosInstance().get<PrivacyPoliceModel>('settings/privacy-policy')
            .pipe(map((response) => response.data));
    }
}

